import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from '../stores/authStore';

const PublicRoutes = () => {
    const { user } = useAuthStore();

    return user && user.emailVerified ? <Navigate to="/" replace /> : <Outlet />;
}

export default PublicRoutes;
